import { locale } from '@/constants/locale';

// redux
import { UserInfo, UserInfoResponse } from '@/redux/auth/auth.type';
import { HomeSliderResponse, Slide } from '@/redux/home/home.types';

const { home } = locale;

export const transformUserInfoData = (data: UserInfoResponse): UserInfo => {
  const { userProfessionalInfo, ...restItems } = data;
  const {
    workEmail,
    workIdentityVerificationStatus,
    workingIndustryType,
    workingIndustry,
    workingDesignation
  } = userProfessionalInfo?.[0] || {};

  return {
    ...restItems,
    workEmail,
    workIdentityVerificationStatus,
    workingIndustryType: workingIndustryType?.name || null,
    workingIndustry: workingIndustry?.name || null,
    workingDesignation: workingDesignation?.name || null
  };
};

export const transformHomeSliderData = (data: HomeSliderResponse): Slide => {
  const {
    id,
    order,
    deal,
    bannerImageUrl,
    blueGlowFadeStart,
    blueGlowFadeEnd
  } = data || {};
  const { title, subtitle, retailer } = deal || {};

  return {
    id,
    order,
    brand: retailer?.name,
    headline: data.customTitle || title || '',
    description: data.customSubtitle || subtitle || '',
    buttonText: home.getTheDeal,
    buttonUrl: deal?.slug ? `/deal/${deal.slug}` : '#',
    ...(data.customLink && {
      customButtonText: home.learnMore,
      customButtonUrl: data.customLink
    }),
    imageUrl: bannerImageUrl || '',
    logoUrl: data.smallBannerImageUrl || retailer?.logo || '',
    dealSlug: deal?.slug,
    retailerSlug: retailer?.slug,
    blueGlowFadeStart: blueGlowFadeStart ?? 35.64,
    blueGlowFadeEnd: blueGlowFadeEnd ?? 81.94
  };
};
